/** The Override? checkbox, saved the moment it is toggled. */

interface EditableFlagCellProps {
  checked: boolean;
  label: string;
  onCommit: (checked: boolean) => void;
  /** f11.6: a validation warning on this cell -- amber outline, still editable. */
  warning?: string;
}

export function EditableFlagCell({ checked, label, onCommit, warning }: EditableFlagCellProps) {
  return (
    <td className={`col-edit${warning ? ' cell-warning' : ''}`} title={warning}>
      <input
        type="checkbox"
        aria-label={label}
        checked={checked}
        onChange={(event) => onCommit(event.target.checked)}
      />
    </td>
  );
}
